var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaiveOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.60526 0 0 5.60526 0 12.5C0 19.3947 5.60526 25 12.5 25C19.3947 25 25 19.3947 25 12.5C25 5.60526 19.3947 0 12.5 0ZM20.4474 18.7632L17.8947 16.2105C17.4474 16.8684 16.8684 17.4474 16.2105 17.8947L18.7632 20.4474C17.0263 21.8156 14.8683 22.6316 12.5 22.6316C6.92105 22.6316 2.36842 18.079 2.36842 12.5C2.36842 10.1317 3.18416 7.97368 4.55263 6.23684L7.10526 8.78947C7.55261 8.13158 8.13158 7.55263 8.78947 7.10526L6.23684 4.55263C7.97373 3.18416 10.1315 2.36842 12.5 2.36842C18.0789 2.36842 22.6316 6.92101 22.6316 12.5C22.6316 14.8683 21.8156 17.0263 20.4474 18.7632Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6743 7C9.54449 7 7 9.54449 7 12.6743C7 15.8042 9.54449 18.3487 12.6743 18.3487C15.8042 18.3487 18.3487 15.8042 18.3487 12.6743C18.3487 9.54449 15.8042 7 12.6743 7ZM14.741 10.7033H13.5464C13.7017 10.9182 13.8092 11.1691 13.8689 11.432H14.741V12.2921L13.8689 12.292C13.6778 13.1999 12.8655 13.8808 11.8979 13.8808H11.6948L13.9646 16.1864L12.6983 16.1865L10.6078 14.072V12.973H11.8979C12.3638 12.973 12.758 12.6862 12.9253 12.292H10.6078V11.4319H12.9253C12.758 11.0258 12.3638 10.7509 11.8979 10.7509L10.6078 10.751V9.84314H14.7291V10.7033L14.741 10.7033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiveOff);
export default __webpack_public_path__ + "static/media/WaiveOff.06413ccfc618cb63513de17f817e73c9.svg";
export { ForwardRef as ReactComponent };